import {Injectable} from '@angular/core';
import {RequesterService} from "../../../../shared/services/requester/requester.service";
import {BehaviorSubject} from "rxjs";
import {DbResponse} from "../../../../shared/interceptors/db-response";
import {Store} from "@ngrx/store";
import * as fromStore from "../../../../store";
import {DbStoreState} from "../../../../store";
import {HostingService} from "../../hosting/hosting.service";
import {Router} from "@angular/router";
import {DbModalService} from "../../../../modules/modal/modal";
import {Config} from "../../../../config/config";
import mockData from "../../../../../assets/json/mock-data.json";
import {map} from "rxjs/operators";

export type BoosterMode = 'standard' | 'balanced' | 'strong' | 'extreme' | 'no_optimize';

@Injectable({
  providedIn: 'root'
})
export class AiBuilderService {

  private ownerWorkspaceId: any;
  private currentWorkspaceId: any;

  constructor(
    private _requester: RequesterService,
    private _hostingService: HostingService,
    private _modalService: DbModalService,
    private _router: Router,
    private _store: Store<DbStoreState>,
  ) {
    this._getWorkspaceEntities();
  }

  private _getWorkspaceEntities(): void {
    this._store.select(fromStore.getWorkspaceIdEntities)
      .subscribe(workspaceIdEntities => {
        this.ownerWorkspaceId = workspaceIdEntities.ownerWorkspaceId;
        this.currentWorkspaceId = workspaceIdEntities.currentWorkspaceId || this.ownerWorkspaceId;
      });
  }

  public getCreatedPages(websiteId: number): BehaviorSubject<DbResponse> {
    if (+websiteId === Config.demoDomainId) {
      const response: any = mockData['get-pages'];
      return new BehaviorSubject<DbResponse>(response);
    }
    return <BehaviorSubject<any>>(this._requester.aiAssistant
      .get(`builder/workspaces/${this.currentWorkspaceId}/domains/${websiteId}/pages`, null, true)
      .pipe(map((response: any): any => {
        if (response && response.success) {
        }
        return response;
      })));
  }

  public getGeneratedWebsiteCount(): BehaviorSubject<DbResponse> {
    return <BehaviorSubject<DbResponse>>(this._requester.aiAssistant
      .get(`templates/workspaces/${this.currentWorkspaceId}/generation-count`, null, true));
  }

  public getUsedAiCreditsCount(): BehaviorSubject<DbResponse> {
    return <BehaviorSubject<DbResponse>>(this._requester.aiAssistant
      .get(`actions/workspaces/${this.currentWorkspaceId}/limits?actionType=ai_trial`, null, true));
  }

  public generateService(formData, businessType, token, language: string = 'english', isEcommerce): BehaviorSubject<DbResponse> {
    let data = {
      ...formData,
      "business_type": businessType,
      "content_language": language,
      captcha_token: token
    };

    if (!!isEcommerce) {
      data = Object.assign({}, data, {
        website_type: "ecommerce",
      });
    }
    return <BehaviorSubject<any>>(this._requester.aiBuilder
      .post(`onboarding/service_generation`, null, data));
  }

  public generateDescription(text, businessType, token, isEcommerce: boolean = false, language: string = 'english'): BehaviorSubject<DbResponse> {
    let data = {text: text, "business_type": businessType, "content_language": language, captcha_token: token};
    if (!!isEcommerce) {
      data = Object.assign({}, data, {
        website_type: "ecommerce",
      });
    }
    return <BehaviorSubject<any>>(this._requester.aiBuilder
      .post(`onboarding/enhance_description`, null, data));
  }

  public searchCategories(text, isEcommerce: boolean = false, hasEcommerceService = true): BehaviorSubject<DbResponse> {
    const data = {input: text};
    /*TODO website type change
    const routeUrl = `onboarding/search_categories` + (isEcommerce ? `?website_type=ecommerce` : ``);
    const routeUrl = `onboarding/search_categories`;*/
    const routeUrl = `onboarding/search_categories` + (isEcommerce ? `?website_type=ecommerce` : `?website_type=basic`);
    return <BehaviorSubject<any>>(this._requester.aiBuilder
      .post(routeUrl, null, data));
  }

  public generateProductDescription(data): BehaviorSubject<DbResponse> {
    return <BehaviorSubject<any>>(this._requester.aiBuilder.post(`ecommerce/product_description`, null, data));
  }
}
